import { render, staticRenderFns } from "./SRDSThreshold.vue?vue&type=template&id=5c17ec4b&"
import script from "./SRDSThreshold.vue?vue&type=script&lang=js&"
export * from "./SRDSThreshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports